import { EnvironmentProviders, effect, inject, provideAppInitializer, untracked } from '@angular/core';
import { User } from '../models/user.model';
import { AuthService } from '../services/auth.service';
import { MixPanelService } from './mixpanel.service';

/**
 * Keeps Mixpanel in sync with the AuthService session, like provideSentryUserSync:
 * - a user appears (app start with a valid session, SSO login, mock auth) -> init + identify
 * - the role changes -> userRole base property updated
 * - the user changes or logs out -> reset (Mixpanel identity + consent cache)
 */
export function provideMixpanelSessionSync(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const authService = inject(AuthService);
    const mixpanel = inject(MixPanelService);
    let signedInEmail: string | null = null;

    effect(() => {
      const user: User | null = authService.currentUser();
      untracked(() => {
        if (!user) {
          if (signedInEmail !== null) mixpanel.reset();
          signedInEmail = null;
          return;
        }
        if (signedInEmail !== null && signedInEmail !== user.email) mixpanel.reset();
        if (signedInEmail === user.email) {
          mixpanel.setUserRole(user.role);
          return;
        }
        signedInEmail = user.email;
        void mixpanel.init(user);
      });
    });
  });
}
